export const getIsAuthorized = (state) => state.user.isAuthorized;

export const getChatbotSettings = (state) => state.user.config.chatbot_settings;

export const getEmail = (state) => state.user.info.email;
